import axios from "axios";
import { getAccessToken, bindAuthInterceptor } from "../utils/authToken";

export { bindAuthInterceptor };

function getApiBaseUrl() {
  return process.env.REACT_APP_API_URL || "";
}

export function getAuthHeaders() {
  const token = getAccessToken();
  return token
    ? { accept: "*/*", Authorization: `Bearer ${token}` }
    : { accept: "*/*" };
}

export async function getMyPermissions() {
  const { data } = await axios.get(`${getApiBaseUrl()}Permission/mine`, {
    headers: getAuthHeaders(),
  });
  return data || { isAdmin: false, roles: [], screens: [] };
}

export async function getPermissionMatrix() {
  const { data } = await axios.get(`${getApiBaseUrl()}Permission/matrix`, {
    headers: getAuthHeaders(),
  });
  return data || { roles: [], screens: [], grants: [] };
}

export async function saveRolePermissions(roleId, grants) {
  const { data } = await axios.put(
    `${getApiBaseUrl()}Permission/role/${encodeURIComponent(roleId)}`,
    { grants },
    { headers: getAuthHeaders() },
  );
  return data;
}

export async function getPermissionUsersByRole(roleId) {
  const { data } = await axios.get(
    `${getApiBaseUrl()}Permission/role/${encodeURIComponent(roleId)}/users`,
    { headers: getAuthHeaders() },
  );
  return Array.isArray(data) ? data : [];
}

export async function getUserPermissions(userId) {
  const { data } = await axios.get(
    `${getApiBaseUrl()}Permission/user/${encodeURIComponent(userId)}`,
    { headers: getAuthHeaders() },
  );
  return data || { userId, isCustom: false, grants: [] };
}

export async function saveUserPermissions(userId, grants) {
  const { data } = await axios.put(
    `${getApiBaseUrl()}Permission/user/${encodeURIComponent(userId)}`,
    { grants },
    { headers: getAuthHeaders() },
  );
  return data;
}

export async function resetUserPermissions(userId) {
  const { data } = await axios.delete(
    `${getApiBaseUrl()}Permission/user/${encodeURIComponent(userId)}`,
    { headers: getAuthHeaders() },
  );
  return data;
}

